import { createTheme } from "../../util";

const blue = createTheme({
	key: "blue",
	label: "Blue",
});

export default blue;